import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { useAppSelector } from "../hook";

export type TmsAssetTreeProps = {
  selectedBranches: string[];
  selectedSegments: string[];
  selectedFleetGroups: string[];
  selectedClients: string[];
  selectedVehicles: string[];
  selectedDrivers: string[];
};

const initialState: TmsAssetTreeProps = {
  selectedBranches: [],
  selectedSegments: [],
  selectedFleetGroups: [],
  selectedClients: [],
  selectedVehicles: [],
  selectedDrivers: [],
};

export const TmsAssetTreeSlice = createSlice({
  name: "tmsAssetTree",
  initialState,
  reducers: {
    setSelectedBranches: (state, action: PayloadAction<string[]>) => {
      state.selectedBranches = action.payload;
    },
    setSelectedSegments: (state, action: PayloadAction<string[]>) => {
      state.selectedSegments = action.payload;
    },
    setSelectedFleetGroups: (state, action: PayloadAction<string[]>) => {
      state.selectedFleetGroups = action.payload;
    },
    setSelectedClients: (state, action: PayloadAction<string[]>) => {
      state.selectedClients = action.payload;
    },
    setSelectedVehicles: (state, action: PayloadAction<string[]>) => {
      state.selectedVehicles = action.payload;
    },
    setSelectedDrivers: (state, action: PayloadAction<string[]>) => {
      state.selectedDrivers = action.payload;
    },
    clearAllFilters: (state) => {
      state.selectedBranches = [];
      state.selectedSegments = [];
      state.selectedFleetGroups = [];
      state.selectedClients = [];
      state.selectedVehicles = [];
      state.selectedDrivers = [];
    },
  },
});

export const {
  setSelectedBranches,
  setSelectedSegments,
  setSelectedFleetGroups,
  setSelectedClients,
  setSelectedVehicles,
  setSelectedDrivers,
  clearAllFilters,
} = TmsAssetTreeSlice.actions;

export const getStoredSelectedBranches = (state: RootState) => state.tmsAssetTree.selectedBranches;
export const getStoredSelectedSegments = (state: RootState) => state.tmsAssetTree.selectedSegments;
export const getStoredSelectedFleetGroups = (state: RootState) => state.tmsAssetTree.selectedFleetGroups;
export const getStoredSelectedClients = (state: RootState) => state.tmsAssetTree.selectedClients;
export const getStoredSelectedVehicles = (state: RootState) => state.tmsAssetTree.selectedVehicles;
export const getStoredSelectedDrivers = (state: RootState) => state.tmsAssetTree.selectedDrivers;

export const useGetStoredSelectedBranches = () => useAppSelector(getStoredSelectedBranches);
export const useGetStoredSelectedSegments = () => useAppSelector(getStoredSelectedSegments);
export const useGetStoredSelectedFleetGroups = () => useAppSelector(getStoredSelectedFleetGroups);
export const useGetStoredSelectedClients = () => useAppSelector(getStoredSelectedClients);
export const useGetStoredSelectedVehicles = () => useAppSelector(getStoredSelectedVehicles);
export const useGetStoredSelectedDrivers = () => useAppSelector(getStoredSelectedDrivers);

export default TmsAssetTreeSlice.reducer;
